import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';

import { StockCountListComponent } from './stock-count-list/stock-count-list.component';
import { CommonModule, DatePipe } from '@angular/common';
import { StockCountRoutingModule } from 'app/modules/stock-count/stock-count-routing.module';
import { StockCountFilterComponent } from 'app/modules/stock-count/stock-count-filter/stock-count-filter.component';
import { StockCountPageContainer } from 'app/modules/stock-count/stock-count-page-container/stock-count-page.container';
import { StockCountDetailComponent } from 'app/modules/stock-count/stock-count-detail/stock-count-detail.component';
import { StockCountLocationComponent } from 'app/modules/stock-count/stock-count-create/stock-count-create-location/stock-count-create-location.component';
import { StockCountLocationContainer } from 'app/modules/stock-count/stock-count-create/stock-count-create.container';
import { StockCountListOrdersComponent } from 'app/modules/stock-count/stock-count-create/stock-count-create-multi-select-orders/stock-count-create-multi-select.component';
import { StockCountOrderComponent } from './stock-count-create/stock-count-create-multi-select-orders/stock-count-order/stock-count-order/stock-count-order.component';
import { StockCountMaterialListComponent } from './stock-count-create/stock-count-material-list/stock-count-material-list.component';
import { StockCountMaterialComponent } from './stock-count-create/stock-count-material-list/stock-count-material/stock-count-order/stock-count-material.component';
import { StockCountModalComponent } from './stock-count-modal/stock-count-modal.component';
import { StockCountPrintComponent } from './stock-count-print/stock-count-print.component';
import { StockCountOrderItemsComponent } from './stock-count-create/stock-count-create-multi-select-orders/stock-count-order-items/stock-count-order-items.component';

@NgModule({
  imports: [CommonModule, StockCountRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [],
  declarations: [
    StockCountFilterComponent,
    StockCountListComponent,
    StockCountPageContainer,
    StockCountDetailComponent,
    StockCountLocationComponent,
    StockCountLocationContainer,
    StockCountListOrdersComponent,
    StockCountOrderComponent,
    StockCountMaterialListComponent,
    StockCountMaterialComponent,
    StockCountModalComponent,
    StockCountPrintComponent,
    StockCountOrderItemsComponent,
  ],
  providers: [DatePipe],
})
export class StockCountModule {}
